// extracted by mini-css-extract-plugin
module.exports = {"emptyList":"empty-list_emptyList__2v0ug"};